module.exports = __webpack_public_path__ + "img/MemberCard2.75502bf0.jpg";